// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8569ae5b","239":"1d59d56f","455":"a8df1761"}[chunkId] + ".chunk.js";
};